<template>
  <v-container fluid fill-height grid-list-md>
    <v-layout wrap>
      <v-flex xs12>
        <v-card class="elevation-4">
          <v-card-text>
            <v-switch
              v-model="hasBonusAddition"
              label="Tambahan bonus berlaku"
            ></v-switch>
            <v-expand-transition
              ><div v-show="hasBonusAddition">
                <v-text-field
                  hint="Tambahan nominal bonus dari pembelian paket ini"
                  persistent-hint
                  outlined
                  label="Tambahan bonus"
                  type="number"
                  v-model="bonusAddition"
                ></v-text-field></div
            ></v-expand-transition>
            <v-switch
              v-model="hasFreeToPlay"
              class="mt-8"
              label="Tambahan 1x Bermain Gratis"
            ></v-switch>
            <v-expand-transition>
              <div v-show="hasFreeToPlay">
                <v-container fluid grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 class="text-left"> </v-flex>
                    <v-flex xs12 md3>
                      <v-text-field
                        v-model="freeToPlayPeriodValue"
                        label="Lama Masa Berlaku 1x Gratis Bermain"
                        persistent-hint
                        :disabled="!hasFreeToPlay"
                        class="mr-4"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md4>
                      <v-select
                        v-model="freeToPlayPeriodUnit"
                        :items="activePeriodUnits"
                        item-value="value"
                        item-text="label"
                        label="Satuan Masa Berlaku 1x Gratis Bermain"
                        persistent-hint
                        dense
                      ></v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-autocomplete
                        label="Wahana 1x Bermain Gratis"
                        hint="Wahana-wahana yang 1 kali dapat dimainkan gratis setiap 1 kali pembelian paket"
                        persistent-hint
                        :items="attractions"
                        item-text="attractionName"
                        item-value="id"
                        multiple
                        chips
                        deletable-chips
                        clearable
                        hide-no-data
                        hide-selected
                        :disabled="!hasFreeToPlay"
                        v-model="choosenFreeAttractions"
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card-text>
          <v-card-actions>
            <v-container fluid fill-height>
              <v-layout wrap justify-start>
                <v-flex xs12>
                  <v-divider light></v-divider>
                </v-flex>
                <v-flex xs12 class="text-right">
                  <v-btn color="tertiary" class="mr-4" :to="backPath" dark
                    >Kembali</v-btn
                  >
                  <v-btn
                    color="secondary"
                    :loading="loading"
                    :disabled="loading"
                    @click="editData"
                    v-if="isEditPermitted"
                    >Ubah<template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="isLoadingFinished"
      top
      :color="loadingMessageColor"
      :timeout="errorTimeout"
    >
      <span v-html="loadingMessage"></span>
      <v-btn dark text @click="isLoadingFinished = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  props: ["entrancePackageId"],
  data() {
    return {
      loading: false,
      isLoadingFinished: false,
      loadingMessage: null,
      loadingMessageColor: "primary",
      errorTimeout: 7000,
      hasFreeToPlay: false,
      choosenFreeAttractions: [],
      freeToPlayPeriodValue: null,
      freeToPlayPeriodUnit: null,
      hasBonusAddition: false,
      bonusAddition: null,
      isEditPermitted: false,
      attractions: [],
      activePeriodUnits: [],
      editPermittedPath: process.env.VUE_APP_ENTRANCEPACKAGE_EDITPERMITTED_PATH,
      activePeriodUnitPath: process.env.VUE_APP_ACTIVEPERIODUNIT_PATH,
      attractionPath: process.env.VUE_APP_ATTRACTION_PATH,
      mainPath: process.env.VUE_APP_ENTRANCEPACKAGE_FREE_TO_PLAY_PATH,
      backPath: process.env.VUE_APP_ENTRANCEPACKAGE_PATH
    };
  },
  methods: {
    fetchEditPermitted() {
      let self = this;
      this.axios
        .get(self.editPermittedPath + "/" + self.entrancePackageId)
        .then(function(response) {
          self.isEditPermitted = response.data;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    },
    fetchAttractions() {
      let self = this;
      this.axios
        .get(self.attractionPath)
        .then(function(response) {
          self.attractions = response.data;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    },
    fetchData() {
      let self = this;
      this.axios
        .get(self.choosenFreeAttractionPath)
        .then(function(response) {
          let data = response.data;
          self.freeToPlayPeriodValue = data.freeToPlayPeriodValue;
          self.freeToPlayPeriodUnit = data.freeToPlayPeriodUnit;
          self.hasFreeToPlay = data.hasFreeTickets;
          self.choosenFreeAttractions = data.freeAttractionIds;
          self.hasBonusAddition = data.hasBonusAddition;
          self.bonusAddition = data.bonusAddition;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    },
    fetchActivePeriodUnits() {
      let self = this;
      this.axios
        .get(self.activePeriodUnitPath)
        .then(function(response) {
          self.activePeriodUnits = response.data;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    },
    editData() {
      this.loading = true;
      this.isLoadingFinished = false;
      let self = this;
      this.axios
        .post(self.mainPath, {
          hasFreeToPlay: self.hasFreeToPlay,
          freeAttractionIds: self.choosenFreeAttractions,
          freeToPlayPeriodUnit: self.freeToPlayPeriodUnit,
          freeToPlayPeriodValue: self.freeToPlayPeriodValue,
          hasBonusAddition: self.hasBonusAddition,
          bonusAddition: self.bonusAddition,
          id: self.entrancePackageId
        })
        .then(function() {
          self.loadingMessage = "Sukses mengubah bonus dan gratis bermain";
          self.loadingMessageColor = "primary";
          self.$vuetify.goTo(0, self.successScrollOptions);
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        })
        .finally(function() {
          self.loading = false;
          self.isLoadingFinished = true;
        });
    }
  },
  computed: {
    choosenFreeAttractionPath() {
      return this.mainPath + "/" + this.entrancePackageId;
    }
  },
  mounted: function() {
    this.fetchEditPermitted();
    this.fetchAttractions();
    this.fetchActivePeriodUnits();
    this.fetchData();
  }
};
</script>

<style></style>
